import React from 'react';
import { GlobeIcon, ShoppingCartIcon, MailIcon } from 'lucide-react';
export function Footer() {
  return <footer className="border-t border-sky-100 bg-white px-4 py-12" data-id="element-207" data-mp="3gfiyctkyyvje">
      <div className="mx-auto max-w-4xl text-center" data-id="element-208" data-mp="32nuhkczrziw3">
        <p className="inline-flex items-center gap-2 font-display text-lg font-bold text-primary" data-id="element-209" data-mp="32pfh6h0y5s0t">
          <ShoppingCartIcon className="h-5 w-5 text-teal" data-id="element-210" data-mp="36pz9966ny5g3" /> COMPRA DIGITAL YA™
        </p>
        <p className="mt-3 font-bold text-slate-700" data-id="element-211" data-mp="3ugbrb9vmhike">
          El sistema para emprendedores argentinos que venden sin publicidad.
        </p>
        <p className="mt-2 text-sm font-medium text-slate-500" data-id="element-212" data-mp="3lecb2jsfmiii">
          Porque vender por redes merece tener un sistema real.
        </p>
        <div className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-medium text-slate-600 sm:flex-row sm:gap-6" data-id="element-213" data-mp="3qcdsz1e4gbse">
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-teal" href="mailto:compradigitalyaa@gmail.com" data-id="element-214" data-mp="2a19tpmiidoxa">
            <MailIcon className="h-4 w-4" data-id="element-215" data-mp="3labq1ri0byo9" /> compradigitalyaa@gmail.com
          </a>
          <a className="inline-flex items-center gap-1.5 transition-colors hover:text-teal" href="https://compradigitalya.com" target="_blank" rel="noopener noreferrer" data-id="element-216" data-mp="3gb8xv7n4lmxp">
            <GlobeIcon className="h-4 w-4" data-id="element-217" data-mp="3q727ai5jt0b9" /> compradigitalya.com
          </a>
        </div>
        <p className="mt-7 border-t border-slate-100 pt-6 text-xs font-medium text-slate-400" data-id="element-218" data-mp="81pdrea6qp79">
          © Compra Digital Ya™ 2026 — Todos los derechos reservados.
        </p>
      </div>
    </footer>;
}